import { useToggle } from 'admin';
import {
  FullDemandSignalDTO,
  FullSupplySignalDTO,
  MatchedSiteMaterialV2,
  PricedDemandSignalDTO,
  PricedSupplySignalDTO,
} from 'api';
import { Button, Grid, Stack } from 'ui';
import { ChevronRightOutlined } from 'ui/icons';

import { MatchedSiteMaterialItemContextProvider } from '../../contexts/MatchedSiteMaterialItemContext';
import { MatchedDemandSignalOverview } from '../MatchedDemandSignalOverview/MatchedDemandSignalOverview';
import { MatchedSiteMaterialItemDrawer } from '../MatchedSiteMaterialItemDrawer/MatchedSiteMaterialItemDrawer';
import { MatchedSupplySignalOverview } from '../MatchedSupplySignalOverview/MatchedSupplySignalOverview';
import { SiteMaterialOverview } from '../SiteMaterialOverview/SiteMaterialOverview';
import { TotalNetTakeRateOverview } from '../TotalNetTakeRateOverview/TotalNetTakeRateOverview';
import { TradeCompanyStatisticsCard } from '../TradeCompanyStatisticsCard/TradeCompanyStatisticsCard';
import { DetailsSection, MatchedSiteMaterialGridContainer } from './styles';

type Props = {
  demandSignal: FullDemandSignalDTO;
  supplySignal?: FullSupplySignalDTO;
  siteMaterial: MatchedSiteMaterialV2;
  sellerOffer?: PricedDemandSignalDTO;
  buyerOffer?: PricedSupplySignalDTO;
  targetMargin?: number;
};

export const MatchedSiteMaterialDemandSignalItem = ({
  demandSignal,
  supplySignal,
  siteMaterial,
  sellerOffer,
  buyerOffer,
  targetMargin,
}: Props) => {
  const { open: openDrawer, isOpen: isDrawerOpen, close: closeDrawer } = useToggle();

  return (
    <MatchedSiteMaterialItemContextProvider
      siteMaterial={siteMaterial}
      demandSignal={demandSignal}
      supplySignal={supplySignal}
      initialSellerOffer={sellerOffer}
      initialBuyerOffer={buyerOffer}
      targetMargin={targetMargin}
    >
      <MatchedSiteMaterialGridContainer container spacing={0}>
        <Grid item xs={12} md={3}>
          <DetailsSection
            sx={{
              backgroundColor: 'background.default',
            }}
          >
            <SiteMaterialOverview />
          </DetailsSection>
        </Grid>
        <Grid item xs={12} md={3.5}>
          <DetailsSection>
            <MatchedSupplySignalOverview
              offerPrice={sellerOffer?.price_details?.seller_price_per_tonne}
              offerPriceCurrency={sellerOffer?.price_details?.seller_currency}
            />
          </DetailsSection>
        </Grid>
        <Grid item xs={12} md={3.5}>
          <DetailsSection>
            <MatchedDemandSignalOverview
              offerPrice={buyerOffer?.price_details?.buyer_price_per_tonne}
              offerPriceCurrency={buyerOffer?.price_details?.buyer_currency}
              estimatedDeliveryDays={buyerOffer?.price_details?.estimated_transit_time_days ?? undefined}
            />
          </DetailsSection>
        </Grid>
        <Grid item xs={12} md={2}>
          <DetailsSection>
            <Stack direction="column" height="100%" gap={2}>
              <TotalNetTakeRateOverview />
              <TradeCompanyStatisticsCard title="Seller trading history" statistics={siteMaterial.seller_statistics} />
              <Button variant="secondary" endIcon={<ChevronRightOutlined />} onClick={openDrawer}>
                Match details
              </Button>
            </Stack>
          </DetailsSection>
        </Grid>
        <MatchedSiteMaterialItemDrawer isOpen={isDrawerOpen} onClose={closeDrawer} />
      </MatchedSiteMaterialGridContainer>
    </MatchedSiteMaterialItemContextProvider>
  );
};
